<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <!-- <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>

      </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <!-- <h4 class="">Our Three Pillars</h4> -->
              <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
              <h2>Contact Us</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="contact" #contact>
  <div class="container">
    <h1>Get In Touch</h1>
    <div class="row">
      <div class="col-md-6">
        <div class="alert alert-success alert-dismissible fade show" role="alert"  *ngIf="formSent">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <strong>Success! Your Message has been recieved</strong>
        </div>
        <form (submit)="submitForm(contactForm)" class="contact-form" #contactForm="ngForm">
          <div class="form-group">
            <label>Name<span class="required-form-field">*</span></label>
            <input type="text" class="form-control" name="name" ngModel placeholder="Your Name" />
          </div>
          <div class="form-group">
            <label>Phone<span class="required-form-field">*</span></label>
            <input
              type="text"
              class="form-control" name="phone"
              ngModel placeholder="Phone Number"
            />
          </div>
          <div class="form-group">
            <label>Email<span class="required-form-field">*</span></label>
            <input type="email" class="form-control" name="email" ngModel placeholder="Email Id" />
          </div>
          <div class="form-group">
            <label
              >How can we help?<span class="required-form-field">*</span></label
            >
            <p>
              <input type="checkbox" ngModel name="ask_a_question" /> Ask a Question
            </p>
            <p>
              <input type="checkbox" ngModel name="meet_with_broker" /> Meet with Local
              Managing Broker
            </p>
            <p>
              <input type="checkbox" ngModel name="contact_agent" /> Contact Agent
            </p>
            <p>
              <input type="checkbox" ngModel name="calculate_mortgage" /> Calculate Mortgage
            </p>
            <p>
              <input type="checkbox" ngModel name="calculate_titlecost" /> Calculate Title Costs
            </p>
            <p>
              <input type="checkbox" ngModel name="schedule_a_meeting" /> Schedule a Meeting
            </p>
            <p>
              <input type="checkbox" ngModel name="virtual_tour" /> Virtual Tour
            </p>
            <p><input type="checkbox" ngModel name="join_stride" /> Join Stride</p>
            <p>
              <input type="checkbox" ngModel name="something_else" /> Something Else
            </p>
          </div>
          <div class="form-group">
            <label>State<span class="required-form-field">*</span></label>
            <input type="text" class="form-control" name="state" ngModel placeholder="State" />
          </div>
          <div class="form-group">
            <textarea
              class="form-control" name="message"
              rows="5"
              ngModel placeholder="Message"
            ></textarea>
          </div>
          <div class="form-group">
            <label
              >How did you hear about Stride?<span class="required-form-field"
                >*</span
              ></label
            >
            <input
              type="text"
              class="form-control" name="source"
              ngModel placeholder="(Referred by another Agent, Email, Facebook etc)"
            />
          </div>
          <button type="submit" class="btn btn-primary">SEND MESSAGE</button>
        </form>
      </div>
      <div class="col-md-6 contact-info">
        <div class="follow">
          <p><b>Address:</b></p>
          <p>
            Dallas Office: <br />17430 Campbell Rd 103, <br /> Dallas, TX  
            75252
          </p>
          <p>
            Houston Office: <br />
            7070 Knights Court, unit 402 <br />
            Missouri City, TX 77459
          </p>
          <p>
            Georgia Office: <br />
            4100 Nine McFarland Drive Suite D <br />
            Alpharetta, GA 30004
          </p>
          <p>
            <i class="fas fa-map-marker-alt"></i>Headquarters - Dallas Office
          </p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3344.638151270298!2d-96.7045402!3d33.0396624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c1958140b0867%3A0xd1b015859473eda7!2sStride%20Real%20Estate!5e0!3m2!1sen!2sus!4v1576612738987!5m2!1sen!2sus"
            width="100%"
            height="250"
            frameborder="0"
            style="border: 0"
            allowfullscreen=""
          ></iframe>
        </div>
        <div class="follow">
          Phone: <b><i class="fas fa-phone"></i>469 329 0962</b>
        </div>
        <div class="follow">
          Email: <b><i class="fas fa-envelope"></i>info@stridere.com</b>
        </div>
        <div class="follow">
          <label><b>Get Social: </b></label>
          <a href="https://www.striderealestate.com/ " class="mr-3"
            ><i class="fas fa-globe icon-item-right"></i
          ></a>
          <a href="https://www.facebook.com/striderealestate" class="mr-3"
            ><i class="fab fa-facebook icon-item-right"></i
          ></a>
          <a href="https://twitter.com/RealStride" class="mr-3"
            ><i class="fab fa-twitter icon-item-right"></i
          ></a>
          <a href="https://www.instagram.com/striderealestate" class="mr-3"
            ><i class="fab fa-instagram icon-item-right"></i
          ></a>
          <a
            href="https://www.linkedin.com/company/stride-real-estate"
            class="mr-3"
            ><i class="fab fa-linkedin icon-item-right"></i
          ></a>
          <a href="https://www.pinterest.com/striderealestate/boards/" class=""
            ><i class="fab fa-pinterest icon-item-right"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
</section>
